export enum TYPES {
  RENTAL = 1,
  SALARY,
  INVOICE,
  COLLECTION,
  SELF_TRANSFER,
  PARTNERSHIP,
  SALARY_BUSINESS,
  INSURANCE,
  UTILITY,
  TAX = "TAX"
}
